module.exports = __webpack_public_path__ + "media/P04.b17e26cd.mp4";